export default "__VITE_ASSET__06511fe7__"